import { __assign } from "tslib";
import { noop } from '@dazn/peng-html5-tools-utils';
import { createFeature } from "./createFeature";
var createPlaceholderFeature = function (_a) {
    var name = _a.name, exports = _a.exports, events = _a.events;
    return createFeature({
        name: name,
        events: events,
        requires: [],
        init: function () {
            return __assign(__assign({}, exports), { destroy: noop });
        },
    });
};
export { createPlaceholderFeature };
//# sourceMappingURL=createPlaceholderFeature.js.map